import { AGGREGATE_COUNCIL_SLUG, COUNCILS, DEFAULT_COUNCIL_SLUG, getCouncilConfig, isAggregateCouncilScope } from "./councils";

export const PUBLIC_PLANNING_COUNCILS = Object.values(COUNCILS).filter((council) => council.publicEnabled);
const joinNames = (values) => {
  const clean = values.filter(Boolean);
  if (clean.length <= 1) return clean[0] || "Edinburgh";
  return `${clean.slice(0, -1).join(", ")} and ${clean[clean.length - 1]}`;
};
const councilPlaceName = (council) => (council?.slug === "edinburgh" ? "Edinburgh" : council?.displayName);

export const AGGREGATE_PLANNING_PLACE_NAME = joinNames(PUBLIC_PLANNING_COUNCILS.map(councilPlaceName));
export const AGGREGATE_PLANNING_AUTHORITY_NAME = joinNames(PUBLIC_PLANNING_COUNCILS.map((council) => council.officialName));
export const PLANNING_COVERAGE_SUMMARY = `Planning applications from ${PUBLIC_PLANNING_COUNCILS.length} Scottish council areas are available on City Scope.`;
export const PLANNING_CURRENT_COVERAGE_COPY = `Current coverage: ${AGGREGATE_PLANNING_PLACE_NAME}.`;

export const PLANNING_COVERAGE_LINKS = [
  { href: "/planning-updates", label: "Scotland's planning applications" },
  { href: "/planning-map", label: "City Scope planning map" },
  ...PUBLIC_PLANNING_COUNCILS.flatMap((council) => {
    const placeName = councilPlaceName(council);
    return [
      { href: `/planning-updates/${council.shortCode}`, label: `${placeName} planning applications` },
      { href: `/planning-map/${council.shortCode}`, label: `${placeName} planning map` },
    ];
  }),
];

export function getPlanningSeoPlaceName(councilSlug = AGGREGATE_COUNCIL_SLUG) {
  if (councilSlug === 'london') return 'London';
  if (isAggregateCouncilScope(councilSlug)) return 'Scotland';
  const council = getCouncilConfig(councilSlug) || getCouncilConfig(DEFAULT_COUNCIL_SLUG);
  if (council?.slug === "edinburgh") return "Edinburgh";
  return council?.displayName || "Edinburgh";
}

export function getPlanningSeoAuthorityName(councilSlug = AGGREGATE_COUNCIL_SLUG) {
  if (councilSlug === 'london') return 'London planning authorities';
  if (isAggregateCouncilScope(councilSlug)) return AGGREGATE_PLANNING_AUTHORITY_NAME;
  const council = getCouncilConfig(councilSlug) || getCouncilConfig(DEFAULT_COUNCIL_SLUG);
  return council?.officialName || "The City of Edinburgh Council";
}

export function getPlanningSeoDescription({
  placeName = 'Scotland',
  surface = "search",
  aggregate = false,
} = {}) {
  const planningApplicationsPhrase =
    aggregate && placeName === 'Scotland'
      ? "Scotland's planning applications"
      : `${placeName} planning applications`;
  const action =
    surface === "map"
      ? `Explore ${planningApplicationsPhrase} on an interactive map`
      : `View and search ${planningApplicationsPhrase}`;
  const fields =
    surface === "map"
      ? "by location, address, category, and status"
      : "by reference number, address, postcode, status, category, and date";
  const expansion = aggregate
    ? ` ${PLANNING_COVERAGE_SUMMARY}`
    : "";
  return `${action} ${fields} with City Scope.${expansion}`;
}
